import { Dayjs } from 'dayjs';
import { formatLocaleDate } from './dateHelpers';
import i18n from '@translations/i18n';

export const formatRelativeTime = (now: Dayjs, date: Dayjs) => {
  const diffMinutes = now.diff(date, 'minute');
  const diffHours = now.diff(date, 'hour');
  const diffDays = now.diff(date, 'day');

  if (diffMinutes < 60) {
    return date.from(now);
  }

  if (diffHours < 24) {
    return date.from(now);
  }

  if (diffDays === 1) {
    return i18n.t('words.yesterdayAt', {
      time: date.format('HH:mm'),
    });
  }

  return formatLocaleDate(date);
};
